import { h, Component } from 'preact'
import { addToCompare, removeFromCompare } from '../helpers/compare'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class AddToCompareIcon extends Component {
  state = {
    isCurrentProductAdded: null,
    announcement: '',
    count: 0
  }
  componentDidMount() {
    const compare = window.localStorage.getItem('compare')
    if (compare) {
      const array = JSON.parse(compare)
      let included = array.indexOf(parseInt(this.props.id, 10)) >= 0
      this.setState({ count: array.length })
      this.setState({
        isCurrentProductAdded: included
      })
    }
  }
  addProduct(productId) {
    addToCompare(productId)
    const compare = window.localStorage.getItem('compare')
    const array = JSON.parse(compare)
    if (array.length > 1) {
      window.location = '/vergelijk'
    } else {
      this.setState({ announcement: 'Voeg nog 1 product toe' })
    }
    this.setState(prevState => ({
      isCurrentProductAdded: !prevState.isCurrentProductAdded
    }))
    window.setTimeout(() => {
      this.setState({
        announcement: ''
      })
    }, 3000)
  }

  removeProduct(productId) {
    this.setState(prevState => ({
      isCurrentProductAdded: !prevState.isCurrentProductAdded
    }))
    removeFromCompare(productId)
  }

  render() {
    if (!this.state.isCurrentProductAdded) {
      return (
        <button
          class="u-clean-button c-product-popup__compare-button"
          onClick={() => {
            this.addProduct(this.props.id)
          }}
        >
          <span className="c-product-hero__compare-text">vergelijk</span>
          <svg
            className="c-icon c-product-hero__compare-icon"
            dangerouslySetInnerHTML={{
              __html: '<use xlink:href="#compare"></use>'
            }}
          />

          {this.state.announcement != '' ? (
            <span
              className="c-product-popup__compare-announce"
              dangerouslySetInnerHTML={{ __html: this.state.announcement }}
            />
          ) : null}
        </button>
      )
    } else {
      return (
        <button
          class="u-clean-button c-product-popup__compare-button c-product-popup__compare-button--fill"
          onClick={() => {
            this.removeProduct(this.props.id)
          }}
        >
          <span className="c-product-hero__compare-text">verwijder</span>
          <svg
            className="c-icon c-product-hero__compare-icon"
            dangerouslySetInnerHTML={{
              __html: '<use xlink:href="#compare"></use>'
            }}
          />

          {this.state.announcement != '' ? (
            <span
              className="c-product-popup__compare-announce"
              dangerouslySetInnerHTML={{ __html: this.state.announcement }}
            />
          ) : null}
        </button>
      )
    }
  }
}

export default AddToCompareIcon



// WEBPACK FOOTER //
// ./src/js/compare/components/AddToCompareIcon.js